export default {"src":"/_next/static/media/bali-beach.cd9d5ac6.svg","height":221,"width":474};